export const supportInfo = {
    to: `support@pacy.ai`,
    subject: `Support Request`, 
}
